export default function PrivacyPolicy({ contentData, initError, initLoader }) {
  return (
    <>
      <div className="static-content">
        <div className="content-section">
          <h3 className="section-title">Privacy Policy</h3>
          <div className="content-body">
            <p className="content-paragraph">
              <b>Welcome to B.A.W!</b> a Bitcoin, highly secured holding platform operated by Bit Aegis Wallet ("us", "we", or "our"). Our privacy policy explains how we collect, use, and share information about you when you access or use our services through our website located at www.bawapp.com & www.bawallet.cloud.
            </p>
          </div>
        </div>
        <div className="content-section">
          <h6 className="subsection-title">Information We Collect</h6>
          <p className="content-paragraph"><strong>Personal Information  :</strong> Includes your first name, last name, email address, contact number, date of birth, and password, that you provide when you register an account.</p>
          <p className="content-paragraph"><strong>Technical Data :</strong> Includes your IP address, browser type, operating system, and other technology on the devices you use to access our website.</p>
        </div>
        <div className="content-section">
          <h6 className="subsection-title">How We Protect Your Information</h6>
          <p className="content-paragraph">We implement a variety of security measures, such as 3 layer transaction protocol & access key locker, to maintain the safety of your personal information when you use our service or enter, submit, or access your personal information.</p>
          <p className="content-paragraph">Despite these measures, the security of information transmitted over the internet can never be guaranteed.</p>
        </div>
        <div className="content-section">
          <h6 className="subsection-title">Your Rights and Choices</h6>
          <p className="content-paragraph"><strong>Account Information :</strong> You may update, correct, or delete information about you at any time by logging into your account and modifying your information.</p>
          <p className="content-paragraph"><strong>Cookies :</strong> You have the choice to accept or refuse cookies. However, if you choose to refuse cookies, some parts of our service may not function properly.</p>
          <p className="content-paragraph"><strong>Communication Preferences :</strong> You can opt-out of receiving promotional communications from us by following the unsubscribe link in those communications.</p>
        </div>
        <div className="content-section">
          <h6 className="subsection-title">Third-Party Links</h6>
          <p className="content-paragraph">Our website may contain links to third-party websites. We are not responsible for the privacy practices or the content of third-party websites.</p>
        </div>
        <div className="content-section">
          <h6 className="subsection-title">Children's Privacy</h6>
          <p className="content-paragraph">Our services are not directed to individuals under the age of 18. We do not knowingly collect personal information from children under 18. If we learn that we have collected personal information from a child under 18, we will take steps to delete such information from our files as soon as possible.</p>
        </div>
        <div className="content-section">
          <h6 className="subsection-title">Changes to This Privacy Policy</h6>
          <p className="content-paragraph">We may update our Privacy Policy from time to time. We will notify you of any changes by posting the new Privacy Policy on this page.</p>
        </div>
        <div className="content-section">
          <h6 className="subsection-title">Contact us</h6>
          <p className="content-paragraph">If you have any questions about these Policies, please contact us:</p>
          <p className="content-paragraph">Bit Aegis Wallet</p>
          <p className="content-paragraph">Email: vexel.cyber.pix@gmail.com</p>
        </div>
      </div>
    </>
  );
}
